/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Settings_Aria_LabelInputs */

const en_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open timing and sync settings`)
};

const fr_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir les parametres de synchronisation`)
};

const de_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timing- und Synchronisierungseinstellungen öffnen`)
};

const it_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri le impostazioni di temporizzazione e sincronizzazione`)
};

const ru_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте настройки времени и синхронизации.`)
};

const es_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir la configuración de sincronización y tiempo`)
};

const zh_cn2_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开定时和同步设置`)
};

const ja_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイミングと同期の設定を開く`)
};

const hi_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमिंग और सिंक सेटिंग्स खोलें`)
};

const pt_pt2_timing_sync_settings_aria_label = /** @type {(inputs: Timing_Sync_Settings_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra as configurações de sincronização e temporização.`)
};

/**
* | output |
* | --- |
* | "Open timing and sync settings" |
*
* @param {Timing_Sync_Settings_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_settings_aria_label = /** @type {((inputs?: Timing_Sync_Settings_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Settings_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timing_sync_settings_aria_label(inputs)
	if (locale === "de") return de_timing_sync_settings_aria_label(inputs)
	if (locale === "it") return it_timing_sync_settings_aria_label(inputs)
	if (locale === "ru") return ru_timing_sync_settings_aria_label(inputs)
	if (locale === "es") return es_timing_sync_settings_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timing_sync_settings_aria_label(inputs)
	if (locale === "ja") return ja_timing_sync_settings_aria_label(inputs)
	if (locale === "hi") return hi_timing_sync_settings_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timing_sync_settings_aria_label(inputs)
	return en_timing_sync_settings_aria_label(inputs)
});